/**
 * @name isValidOrderId
 * @public
 * @description Validates if a string represents a valid order ID.
 * A valid order ID must consist only of digits (0-9) and have a maximum length of 16 characters.
 * @param {string|number} orderId - The order ID to validate
 * @returns {boolean} Returns true if the order ID is valid, false otherwise
 */
export default function isValidOrderId(orderId) {
  const re = /^[0-9]+$/;
  return re.test(String(orderId)) && String(orderId).length <= 16;
}
